/*

  s e t t i n g s
  Settings

  :description:
  A file to hold onto our settings.

*/

//
//  :statics:
export const VERSION = `v2.0.1`

//
//  :environment:
export const ENVIRONMENT = "dev"
